module.exports = __webpack_public_path__ + "img/htkj_09.93ac098a.jpg";